// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Portal_pageWrapper__EMrqw","portalContainer":"Portal_portalContainer__VYe+G"};